const {h, render, Component} = require('preact');

class RefundReasonOptions extends Component {
  constructor(props) {
    super(props);
    this.getRefundReasonOptions = this.getRefundReasonOptions.bind(this);
  }

  getRefundReasonOptions() {
    let metadata = this.props.metadata;
    let refundReasonOptions = []
    let refundReasons = metadata.refundReasons
    let refundReasonKeys = Object.keys(refundReasons)
    refundReasonOptions.push(<option value="" disabled selected="selected">{I18n.translate("js.modules.support.choose_refund_reason")}</option>)
    refundReasonKeys.forEach(function (key) {
      refundReasonOptions.push(
        <option value={refundReasons[key]}>{I18n.translate("js.modules.support." + key)}</option>
      )
    });
    return refundReasonOptions;
  }

  render() {
    return (
      <div class="gig-field-dropdown" >
        <label for="refund-reasons"></label>
        <select id="refund-reasons" name="list" onChange={this.props.handleClick}>
          {this.getRefundReasonOptions()}
        </select>
      </div>
    )
  }
}

module.exports = RefundReasonOptions